/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ResetPasswordUser_data = {
    readonly user: {
        readonly id: string;
        readonly email: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
    } | null;
    readonly error: string | null;
    readonly " $refType": "ResetPasswordUser_data";
};
export type ResetPasswordUser_data$data = ResetPasswordUser_data;
export type ResetPasswordUser_data$key = {
    readonly " $data"?: ResetPasswordUser_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ResetPasswordUser_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResetPasswordUser_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "error",
      "storageKey": null
    }
  ],
  "type": "VerifyTokenPayload",
  "abstractKey": null
};
(node as any).hash = '40b4076da4e766b3a6addccce72e78fb';
export default node;
